import { NavigateFunction } from 'react-router-dom'
import { fireAnalytics } from '../../../utils/firebase'
import { buildProfileUrl } from '../../../utils/navigationHelpers.ts'
import { PUBLICAR_OBRA_AGENTE_PROMPT } from '../../../utils/conversationalMode/conversationalQuickActions.ts'
import {
  getSessionId,
  getDeviceCategory,
  getTimeOnDashboard,
  getCurrentTab,
  trackActionClicked,
} from '../../../utils/analyticsHelpers.ts'
import { openFeedTextModal as openFeedTextModalAction } from '../../../store/actions'

export interface ActionHandler {
  id: string
  handler: (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number, dispatch?: any) => void
}

const getStandardParams = (userId?: string, tab?: string, position?: number) => {
  return {
    session_id: getSessionId(),
    tab_active: tab || getCurrentTab(),
    action_position: position || 0,
    time_on_dashboard: getTimeOnDashboard(),
    source: 'dashboard',
    previous_page: '/dashboard',
    device_category: getDeviceCategory()
  }
}

export const actionHandlers = {
  'analizar-docs-obra-cotizaciones': (
    navigate: NavigateFunction,
    userId?: string,
    openFeedTextModal?: (config: { text: boolean }) => void,
    tab?: string,
    position?: number
  ) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_analizar_docs_obra_cotizaciones', {
      action: 'analizar_documentacion_obra_cotizaciones',
      category: 'conversational_agent',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/dashboard', {
      state: { conversationalShortcutMessage: PUBLICAR_OBRA_AGENTE_PROMPT }
    })
  },

  'presupuestos-obra': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_presupuestos_obra', {
      action: 'presupuestos_para_mi_obra',
      category: 'obras_privadas',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/obrasprivadas/crear')
  },

  'cotizar-obras': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_cotizar_obras', {
      action: 'cotizar_en_obras',
      category: 'obras_privadas',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/obrasprivadas/explorar')
  },

  'obras-publicas': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_obras_publicas', {
      action: 'obras_publicas',
      category: 'obras_publicas',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/obraspublicas')
  },

  'estimacion-costos': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_estimacion_costos', {
      action: 'estimacion_costos',
      category: 'cotizacion_materiales',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/cotizaciondemateriales/estimacion-costos')
  },

  'cotizar-materiales': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_cotizar_materiales', {
      action: 'cotizar_materiales',
      category: 'cotizacion_materiales',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/cotizaciondemateriales/crear')
  },

  'cotizaciones-materiales': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_cotizaciones_materiales', {
      action: 'cotizaciones_materiales',
      category: 'cotizacion_materiales',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/cotizaciondemateriales/explorar')
  },

  'encontrar-profesionales': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_encontrar_profesionales', {
      action: 'encontrar_profesionales',
      category: 'profesionales',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/buscar-perfiles')
  },
/* 
  'trabajadores-obra': (navigate: NavigateFunction, userId?: string) => {
    fireAnalytics('dashboard_action_trabajadores_obra', {
      action: 'trabajadores_para_mi_obra',
      category: 'mercado_trabajo',
      edify_user_id: userId
    })
    navigate('/mercado-de-trabajo/explorar')
  }, */

  'postularme-ofertas': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_postularme_ofertas', {
      action: 'postularme_a_ofertas_trabajo',
      category: 'mercado_trabajo',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/bolsa-trabajo')
  },

  'publicar-oferta-trabajo': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_publicar_oferta_trabajo', {
      action: 'publicar_oferta_trabajo',
      category: 'mercado_trabajo',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/mercado-de-trabajo/crearoferta')
  },

  'explorar-servicios': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_explorar_servicios', {
      action: 'explorar_servicios_productos',
      category: 'marketplace',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/marketplace/explorar')
  },

  'ofrecer-servicios': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number, dispatch?: any) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_ofrecer_servicios', {
      action: 'ofrecer_servicios_productos',
      category: 'marketplace',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    
    const openFeedTextModalString = openFeedTextModal?.toString() || ''
    const isOpenFeedTextModalValid = openFeedTextModal && 
      typeof openFeedTextModal === 'function' && 
      openFeedTextModalString !== '() => {}' &&
      !openFeedTextModalString.includes('() => {}')
    
    if (isOpenFeedTextModalValid) {
      openFeedTextModal({ text: true })
    } else if (dispatch) {
      dispatch(openFeedTextModalAction({ text: true }))
    }
  },

  'comercializar-documentacion': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_comercializar_documentacion', {
      action: 'comercializar_documentacion',
      category: 'project_documentation',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/documentacion-de-obra/crear')
  },

  'backoffice': (navigate: NavigateFunction, userId?: string, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    trackActionClicked()
    fireAnalytics('dashboard_action_backoffice', {
      action: 'backoffice_access',
      category: 'admin',
      edify_user_id: userId || '',
      ...getStandardParams(userId, tab, position)
    })
    navigate('/backoffice')
  },

  'mis-proyectos': (navigate: NavigateFunction, userData?: any, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    if (!userData) return
    
    trackActionClicked()
    fireAnalytics('dashboard_action_mis_proyectos', {
      action: 'mis_proyectos_en_edify',
      category: 'profile_navigation',
      edify_user_id: userData.id,
      ...getStandardParams(userData.id, tab, position)
    })
    
    const userName = userData.type === "COMPANY" 
      ? userData.razon_social 
      : `${userData.name} ${userData.last_name}`;
    const profileUrl = buildProfileUrl(String(userData.id), userName, 'Oportunidades');
    navigate(profileUrl);
  },

  'mis-cotizaciones-materiales': (navigate: NavigateFunction, userData?: any, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    if (!userData) return
    
    trackActionClicked()
    fireAnalytics('dashboard_action_mis_cotizaciones_materiales', {
      action: 'mis_cotizaciones_materiales',
      category: 'profile_navigation',
      edify_user_id: userData.id,
      ...getStandardParams(userData.id, tab, position)
    })
    
    const userName = userData.type === "COMPANY" 
      ? userData.razon_social 
      : `${userData.name} ${userData.last_name}`;
    const profileUrl = buildProfileUrl(String(userData.id), userName, 'Gestión', {
      section: 'cotizaciones',
    });
    navigate(profileUrl);
  },

  'mis-postulaciones': (navigate: NavigateFunction, userData?: any, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    if (!userData) return
    
    trackActionClicked()
    fireAnalytics('dashboard_action_mis_postulaciones', {
      action: 'mis_postulaciones',
      category: 'profile_navigation',
      edify_user_id: userData.id,
      ...getStandardParams(userData.id, tab, position)
    })
    
    const userName = userData.type === "COMPANY" 
      ? userData.razon_social 
      : `${userData.name} ${userData.last_name}`;
    const profileUrl = buildProfileUrl(String(userData.id), userName, 'Gestión', {
      section: 'accesos',
    });
    navigate(profileUrl);
  },

  'mis-productos-servicios': (navigate: NavigateFunction, userData?: any, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    if (!userData) return
    
    trackActionClicked()
    fireAnalytics('dashboard_action_mis_productos_servicios', {
      action: 'mis_productos_servicios',
      category: 'profile_navigation',
      edify_user_id: userData.id,
      ...getStandardParams(userData.id, tab, position)
    })
    
    const userName = userData.type === "COMPANY" 
      ? userData.razon_social 
      : `${userData.name} ${userData.last_name}`;
    const profileUrl = buildProfileUrl(String(userData.id), userName, 'Productos/Servicios');
    navigate(profileUrl);
  },

  'mis-documentaciones': (navigate: NavigateFunction, userData?: any, openFeedTextModal?: (config: { text: boolean }) => void, tab?: string, position?: number) => {
    if (!userData) return
    
    trackActionClicked()
    fireAnalytics('dashboard_action_mis_documentaciones', {
      action: 'mis_documentaciones_obra',
      category: 'profile_navigation',
      edify_user_id: userData.id,
      ...getStandardParams(userData.id, tab, position)
    })
    
    const userName = userData.type === "COMPANY" 
      ? userData.razon_social 
      : `${userData.name} ${userData.last_name}`;
    const profileUrl = buildProfileUrl(String(userData.id), userName, 'Gestión', {
      section: 'documentaciones',
    });
    navigate(profileUrl);
  },
}

